import React from 'react';
import {Trans} from 'gatsby-plugin-react-i18next';
import {MenuLink} from '../utils/types';

export const useCases: MenuLink[] = [
  {
    icon: 'in-store',
    slug: 'monei-pay/retail-POS-system',
    title: <Trans>Retail & In-Store Payments</Trans>
  },
  {
    icon: 'restaurant',
    slug: 'monei-pay/qr-code-payment-restaurant',
    title: <Trans>Restaurant Payments</Trans>
  },
  {
    icon: 'scissors',
    slug: 'monei-pay/pos-systems-for-hair-salon',
    title: <Trans>Hair Salon Payments</Trans>
  },
  {icon: 'taxi', slug: 'monei-pay/pos-systems-for-taxis', title: <Trans>Taxi Payments</Trans>},
  {
    icon: 'freelancer',
    slug: 'monei-pay/pos-for-freelancers',
    title: <Trans>Freelancer Payments</Trans>
  },
  {
    icon: 'food-truck',
    slug: 'monei-pay/food-truck-pos-system',
    title: <Trans>Food Truck Payments</Trans>
  },
  {
    icon: 'dentist',
    slug: 'monei-pay/accept-payments-dental-practice',
    title: <Trans>Dental Practice Payments</Trans>
  },
  {
    icon: 'legal',
    slug: 'monei-pay/legal-billing-software',
    title: <Trans>Legal Billing Software</Trans>
  }
];
